import React, { Component } from 'react';
import Navigation from './Navigation.js'
import Footer from './Footer.js'
import './App.css';


class About extends Component {
  
  render() {
    return (
      <div>
        <header>
            <img src="/img/asphalt-driveway-calculator-logo.png" className="logo" alt="Asphalt Driveway Calculator" />
            <a href="/" className="logo-title">Asphalt Driveway Calculator</a>
            <nav className="menu">
                <Navigation />
            </nav>
      </header>
         <div className="section">
          <h1>About</h1>
          <div>
            <p>Welcome to the Asphalt Driveway Calculator! Our mission is to provide you with an easy-to-use tool that helps you estimate the amount of asphalt needed and the associated costs for your driveway project. 
            </p>

            <p>Whether you're planning to pave a new driveway, repair an existing one, or simply need a quick calculation, our calculator is designed to give you accurate results based on your input dimensions and specifications.</p>
            
            <h2>How It Works</h2>
            <p>Our calculator allows you to enter the width, length, and depth of your driveway in various units such as inches, feet, yards, centimeters, or meters. </p>
             <p>You can also input the average cost per ton of asphalt to get an estimated total cost. We do all the complex conversions and calculations for you, ensuring you receive the information in convenient units like cubic feet, cubic yards, pounds, and tons.</p>
            

            <h2>Our Goal</h2>
        
               <p>We aim to simplify the planning process for homeowners, contractors, and anyone else who needs to calculate asphalt requirements efficiently and accurately. By providing this tool, we hope to save you time and effort, allowing you to focus more on the details that matter most in your project.</p>

               <p>Thank you for choosing the Asphalt Driveway Calculator. We appreciate your trust and look forward to assisting you in making your driveway projects a success!</p>
            

          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default About;